import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bf-modal bf-modal--profile-delete bf-modal--has-sections" }
const _hoisted_2 = { class: "bf-modal__section" }
const _hoisted_3 = { class: "d-flex justify-content-between" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "bf-heading-script text-primary mb-3" }, "Konto löschen", -1)
const _hoisted_5 = { class: "flex-shrink-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "Wenn du dein buggyFit-Konto endgültig löschen möchtest, kannst du das hier tun. Gib zur Bestätigung bitte dein aktuelles Passwort ein.", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Konto löschen ")
const _hoisted_10 = { class: "fa fa-fw fa-spinner fa-spin ml-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "d-none"
}, "Konto löschen", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextField = _resolveComponent("TextField")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    modelValue: _ctx.shownLocal,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.shownLocal) = $event)),
    close: _ctx.closeModal
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("form", {
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"])),
            novalidate: "",
            class: ""
          }, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("a", {
                  href: "#",
                  class: "modal-close-button",
                  "aria-label": "Schließen",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["prevent"]))
                }, _hoisted_7)
              ])
            ]),
            _hoisted_8,
            _createVNode(_component_TextField, {
              class: "mb-4",
              type: "password",
              field: "password",
              errors: _ctx.errors,
              modelValue: _ctx.form.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.password) = $event)),
              label: "Aktuelles Passwort",
              prefix: "profile-delete"
            }, null, 8, ["errors", "modelValue"]),
            _createElementVNode("a", {
              href: "#",
              class: "btn btn-lg btn-danger",
              onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
            }, [
              _hoisted_9,
              _withDirectives(_createElementVNode("i", _hoisted_10, null, 512), [
                [_vShow, _ctx.loading]
              ])
            ]),
            _hoisted_11
          ], 32)
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "close"]))
}